import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default, { useEffect } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import cssVarPonyfill from 'css-vars-ponyfill';
import loadFonts from './fonts.js';
import theme from '../theme/index.js';
var _excluded = ["resetCSS", "fonts", "includeCssVarPolyfill", "theme"];
var DesignsystemProvider = function DesignsystemProvider(props) {
  var _props$resetCSS = props.resetCSS,
    resetCSS = _props$resetCSS === void 0 ? true : _props$resetCSS,
    _props$fonts = props.fonts,
    fonts = _props$fonts === void 0 ? true : _props$fonts,
    _props$includeCssVarP = props.includeCssVarPolyfill,
    includeCssVarPolyfill = _props$includeCssVarP === void 0 ? false : _props$includeCssVarP,
    _props$theme = props.theme,
    theme$1 = _props$theme === void 0 ? theme : _props$theme,
    rest = _objectWithoutProperties(props, _excluded);
  useEffect(function () {
    if (fonts) {
      loadFonts();
    }
    if (includeCssVarPolyfill) {
      cssVarPonyfill({
        preserveVars: true,
        onlyLegacy: true,
        watch: true,
        include: 'style'
      });
    }
  }, [fonts, includeCssVarPolyfill]);
  return /*#__PURE__*/React__default.createElement(ChakraProvider, _extends({
    resetCSS: resetCSS,
    theme: theme$1
  }, rest));
};
var DesignsystemProvider$1 = DesignsystemProvider;
export { DesignsystemProvider$1 as default };